class GetServiceWorker {

    constructor() {
        if('serviceWorker' in navigator) {
            window.addEventListener('load', function() {
                navigator.serviceWorker.register('/service-worker.js').then(function(registration) {
                    // console.log('ServiceWorker registration successful with scope: ', registration.scope);
                }, function(error) {
                    console.error('ServiceWorker registration failed: ', error);
                });
            });
        } else {
            console.error('serviceWorker not supported');
            return;
        }
    }
}
export default new GetServiceWorker();